/**
 * Soft-steer CTA during product onboarding — Linear-calm, not a wizard.
 * "Finish later" parks the durable workflow; no multi-field intake form.
 */

import { useDeferProductOnboarding } from '../../hooks/useProductOnboarding';

export function ProductOnboardingBanner() {
  const defer = useDeferProductOnboarding();

  return (
    <div
      className="space-y-1 bg-muted px-3 py-2 text-caption text-muted-foreground"
      data-testid="product-onboarding-banner"
    >
      <div className="flex items-center justify-between gap-3">
        <span>Shogun is helping you get set up.</span>
        <button
          type="button"
          className="shrink-0 text-caption text-foreground underline-offset-2 hover:underline disabled:opacity-50"
          data-testid="product-onboarding-defer"
          disabled={defer.isPending}
          onClick={() => {
            void defer.mutateAsync();
          }}
        >
          {defer.isPending ? 'Saving…' : 'Finish later'}
        </button>
      </div>
      {defer.error ? (
        <p className="text-destructive" data-testid="product-onboarding-defer-error">
          {defer.error.message}
        </p>
      ) : null}
    </div>
  );
}
